
export class CookieHandler {
    constructor(private store: any) {
        this.store = store
    }

    setCookie = (cookieName: string, cookieValue: any, exDays: number = 30) => {
        const day = new Date();
        day.setTime(day.getTime() + (exDays*24*60*60*1000));
        let expires = "expires=" + day.toUTCString();

        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    }

    getCookie = (cookieName: string) => {
        let match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));

        if(match === null) {
            return false
        } else {
            return match[2];
        }
    }

    deleteCookie = (cookieName: string) => {
        const expires = 'expires=Thu, 01-Jan-1970 00:00:01 GMT';

        document.cookie = cookieName + '=;' + expires + ';path=/';
    }

    acceptCookies = (all: boolean = false) => {
        const analyticsCheckbox = document.querySelector('#analytics-cookies-checkbox') as HTMLInputElement;
        const functionalCheckbox = document.querySelector('#functional-cookies-checkbox') as HTMLInputElement;

        if (all) {
            this.setCookie('analyticsCookies', true);
            this.setCookie('functionalCookies', true);
            this.store.setFunctionalCookies(true)
        } else {
            if(analyticsCheckbox && analyticsCheckbox.checked === true) {
                this.setCookie('analyticsCookies', true);
            } else {
                this.deleteCookie('analyticsCookies')
            }
    
            if(functionalCheckbox && functionalCheckbox.checked === true) {
                this.setCookie('functionalCookies', true);
                this.store.setFunctionalCookies(true)
            } else {
                this.deleteCookie('functionalCookies')
                this.store.setFunctionalCookies(false)
            }
        }

        this.setCookie('showCookieConsent', false);
        this.setCookie('essentialCookies', true);

        analyticsCheckbox.disabled = true;
        functionalCheckbox.disabled = true;
    }

    resetCookies = () => {
        const analyticsCheckbox = document.querySelector('#analytics-cookies-checkbox') as HTMLInputElement;
        const functionalCheckbox = document.querySelector('#functional-cookies-checkbox') as HTMLInputElement;

        // remove cookies or reset them to default values
        analyticsCheckbox.checked = false;
        functionalCheckbox.checked = false;

        this.deleteCookie('analyticsCookies');
        this.deleteCookie('functionalCookies');
    }
}